import { useCallback, useMemo } from "react";
import { useCsAttributes, useCsConfigurationApi, } from "@plansoft-configuration-renderer/framework";
import { PluginHelper, findInLayoutCell, useCurrentLayoutCell, } from "@plansoft-configuration-renderer/layout";
import { AttributeGroupBehavior } from "./AttributeGroupProps";
/**
 * Can be used to reset an attribute group.
 *
 * ⚠️ Won't work in the layout editor
 *
 * @param options
 * @returns
 */
export function useAttributeGroup(options) {
    const { groupId, groupBehavior } = options;
    const attributes = useCsAttributes();
    const { resetAttributes } = useCsConfigurationApi();
    const currentCell = useCurrentLayoutCell({
        visibleLayoutOnly: groupBehavior === AttributeGroupBehavior.VisibleAttributes,
    });
    const getTechnicalAttributes = useCallback(() => {
        return attributes.filter((attribute) => attribute.groups.includes(groupId));
    }, [groupId, attributes]);
    const getAttributes = useCallback(() => {
        if (!currentCell) {
            return [];
        }
        const groupAttributeCells = findInLayoutCell(currentCell, (node) => PluginHelper.getPluginId(node).startsWith("Attribute:"));
        return attributes.filter((attribute) => groupAttributeCells.find((cell) => PluginHelper.getPluginProps(cell).identifier === attribute.id));
    }, [currentCell, attributes]);
    const groupAttributes = useMemo(() => {
        if (groupBehavior === AttributeGroupBehavior.TechnicalGroup) {
            return getTechnicalAttributes();
        }
        return getAttributes();
    }, [getAttributes, getTechnicalAttributes, groupBehavior]);
    const isGroupComplete = useMemo(() => groupAttributes.every((attr) => attr.isComplete), [groupAttributes]);
    const resetGroup = useCallback(() => {
        resetAttributes(groupAttributes.map((attribute) => ({
            attributeId: attribute.id,
            attributePath: attribute.path,
        })));
    }, [resetAttributes, groupAttributes]);
    return {
        resetGroup,
        groupAttributes,
        isGroupComplete,
    };
}
//# sourceMappingURL=useAttributeGroup.js.map